import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-bold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-[#042854]';
  const variants = {
    primary: 'bg-[#a1da52] text-[#1E3E65] hover:bg-[#8ec542]',
    secondary: 'bg-white text-[#1E3E65] border-2 border-[#1E3E65] hover:bg-[#1E3E65] hover:text-white',
    outline: 'border-2 border-white/20 text-white hover:bg-white/10',
    ghost: 'text-white hover:bg-white/10 hover:text-[#a1da52]'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-114">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-115" />}
      {children}
    </button>;
}